export default __webpack_public_path__ + "static/media/paco_cruz_fibromialgia_en_positivo.4feb7d01.jpg";